var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "15",
        height: "18",
        viewBox: "0 0 15 18",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          d: "M4.6875 0.75C5.25791 0.75 5.71875 1.21084 5.71875 1.78125V2.8125H9.84375V1.78125C9.84375 1.21084 10.3046 0.75 10.875 0.75C11.4454 0.75 11.9063 1.21084 11.9063 1.78125V2.8125H13.4531C14.3071 2.8125 15 3.50537 15 4.35938V5.90625H0.5625V4.35938C0.5625 3.50537 1.25537 2.8125 2.10938 2.8125H3.65625V1.78125C3.65625 1.21084 4.11709 0.75 4.6875 0.75ZM0.5625 6.9375H15V15.7031C15 16.5571 14.3071 17.25 13.4531 17.25H2.10938C1.25537 17.25 0.5625 16.5571 0.5625 15.7031V6.9375ZM3.14063 9C2.85703 9 2.625 9.23203 2.625 9.51562V12.6094C2.625 12.893 2.85703 13.125 3.14063 13.125H6.23438C6.51797 13.125 6.75 12.893 6.75 12.6094V9.51562C6.75 9.23203 6.51797 9 6.23438 9H3.14063Z",
          fill: "#010A11",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }